module.exports = __webpack_public_path__ + "static/media/ios-pint.5ff0a21d.svg";